import Cookies from 'js-cookie';
export const CURRENT_LANGUAGE = 'CURRENT_LANGUAGE';

export const currentLanguage = (result) => {
    // Change the cookie to the new language
    Cookies.set('language', result, { expires: 365 })
    return {
        type: CURRENT_LANGUAGE,
        payload: result
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/current-language.js